import { doGet, doPost } from './Api';

export default class TokenAuthorization {
  static async responseTokenAuthorization() {
    const response = await doGet(process.env.REACT_APP_GET_TOKEN);
    return response.data;
  }

  static async getTokenAuthPD() {
    const response = await doGet(`${process.env.REACT_APP_BASE_URL_WSPD}api/auth/token/180`);
    return response.data.data;
  }

  static async loginToken180() {

    const response = await doPost(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/session-pd/login`);

    return response.data;

  }

  static async getToken180() {
    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/session-pd/token`);

    console.log(response);

    return response.data;
  }

  static async logoutToken({token}) {
    const response = await doPost(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/session-pd/logout`, {},token);
    return response;
  }

}
